import useStore from '../../hooks/use_store'
import ImagesTable from '../images_table'
import QueryState from '../query_state'
import { useParams } from 'react-router-dom'

export default function Select({ assetID, field, onNewImageSelected }) {
  const { updateModel } = useStore()
  const { cycleID } = useParams()

  const saveImage = (assetImage) => {
    updateModel.mutate(
      {
        endpoint: '/asset-images',
        id: assetImage.id,
        data: {
          asset_id: assetID,
          field_id: field.id,
          cycle_id: cycleID,
        },
      },
      {
        onSuccess: async () => {
          onNewImageSelected(assetImage)
        },
      }
    )
  }
  return (
    <QueryState isLoading={updateModel.isLoading}>
      <ImagesTable type='unmatched' onClick={(assetImage) => saveImage(assetImage)} />
    </QueryState>
  )
}
